import { ActionFetch } from '@/store/actionTypes'
import { API } from '@/store/apiPath'
import { AxiosRequest } from '@/store/axiosHelper'
import { MutationStore, MutationView } from '@/store/mutationTypes'

const request = {
  actions: {
    [ActionFetch.CONFIG.SUBJECT.LIST]: ({ commit }, $params = {}) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      return AxiosRequest(API.config.subject.list($params))
        .then(($res) => {
          const data = $res.data
          if (data.success && data.data) {
            commit(MutationStore.CONFIG.SUBJECT.LIST, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.CONFIG.SUBJECT.CREATE]: (
      { commit, rootState },
      $params = {},
    ) => {
      commit(MutationView.SET_LOADING_SCREEN, true)
      let user = rootState.cmsUser

      if (!user) {
        user = JSON.parse(localStorage.getItem('cmsUser'))
      }

      $params.createdBy = user.id
      $params.updatedBy = user.id

      return AxiosRequest(API.config.subject.create(), $params, user.token)
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.CONFIG.SUBJECT.CREATE, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.CONFIG.SUBJECT.UPDATE]: (
      { commit, rootState },
      $params = {},
    ) => {
      commit(MutationView.SET_LOADING_SCREEN, true)
      let user = rootState.cmsUser

      if (!user) {
        user = JSON.parse(localStorage.getItem('cmsUser'))
      }

      $params.updatedBy = user.id

      return AxiosRequest(
        API.config.subject.update($params.id),
        $params,
        user.token,
      )
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.CONFIG.SUBJECT.UPDATE, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },

    [ActionFetch.CONFIG.SUBJECT.DELETE]: ({ commit, rootState }, $id) => {
      commit(MutationView.SET_LOADING_SCREEN, true)

      const user =
        rootState.cmsUser || JSON.parse(localStorage.getItem('cmsUser'))

      return AxiosRequest(API.config.subject.delete($id), {}, user.token)
        .then(($res) => {
          const data = $res.data

          if (data.success && data.data) {
            commit(MutationStore.CONFIG.SUBJECT.DELETE, data.data)
          }
          commit(MutationView.SET_LOADING_SCREEN, false)
          return data
        })
        .catch((error) => {
          commit(MutationView.SHOW_MODAL_ALERT, error.message)
          commit(MutationView.SET_LOADING_SCREEN, false)
        })
    },
  },
}

export default request
